import { createContext, useContext } from 'react';
import { CalendarStore } from '@uplift/store';

export const CalendarStoreContext = createContext<CalendarStore | null>(null);

export function useCalendarStore() {
  const calendarStore = useContext(CalendarStoreContext);

  if (!calendarStore) {
    throw new Error('useCalendarStore must be used within a CalendarStoreProvider');
  }

  return calendarStore;
}
